/* Dauber HQ scroll parallax.
 * Translates [data-parallax-speed] elements on Y axis based on distance from
 * viewport center, clamped to [data-parallax-max] (default Infinity).
 *
 * Source: design_handoff_landing/README.md §"Parallax"
 */

(function () {
  'use strict';

  var elements = [];
  var raf = 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    elements = Array.prototype.map.call(
      document.querySelectorAll('[data-parallax-speed]'),
      function (el) {
        return {
          el: el,
          speed: parseFloat(el.getAttribute('data-parallax-speed')) || 0.3,
          max: parseFloat(el.getAttribute('data-parallax-max')) || Infinity
        };
      }
    );
  }

  function update() {
    var vh = window.innerHeight;
    var viewportCenter = vh / 2;

    elements.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      var sectionCenter = rect.top + rect.height / 2;
      var offset = (sectionCenter - viewportCenter) * -item.speed;
      var clamped = Math.max(-item.max, Math.min(item.max, offset));
      item.el.style.transform = 'translate3d(0,' + clamped.toFixed(1) + 'px,0)';
    });
  }

  function onScroll() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }

  function init() {
    if (reducedMotion) return;
    collect();
    if (!elements.length) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
